const selectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    productMedia: document.querySelector('[data-productMedia]')
  };

  const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
  window.productMedia = mediaJSON;
  class TemplateProductJS {
    constructor() {
      
      let  totalPrice = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
        totalPrice = totalPrice.replace("$","");
        totalPrice = totalPrice.replace("€","");
        totalPrice = parseFloat(totalPrice);
        let  freeShipping   = parseFloat(window.globalVariables.free_shipping);
        let  freeTrial   = parseFloat(window.globalVariables.free_trial);
       if(document.querySelectorAll("[data-free-trial]").length > 0){
        if(totalPrice >= freeTrial){
          document.querySelector("[data-free-trial]").classList.remove("d-none");
          document.querySelector("[data-free-shipping]").classList.add("d-none");

        }else if(totalPrice >= freeShipping){
          document.querySelector("[data-free-shipping]").classList.remove("d-none");
          document.querySelector("[data-free-trial]").classList.add("d-none");

        }else{
          document.querySelector("[data-free-shipping]").classList.add("d-none");
          document.querySelector("[data-free-trial]").classList.add("d-none");

        }
       }

     


      // Custom code for product page goes here
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            document.querySelector("[data-sub-description]").classList.add("d-none");
            document.querySelector("[add_scroll]").classList.remove('scroll-added')
            document.body.classList.remove('fixed-activated');
          }else{
            document.querySelector("[data-sub-description]").classList.remove("d-none");
            document.querySelector("[add_scroll]").classList.add('scroll-added');
            document.body.classList.add('fixed-activated');
          }
        })
      })
      io.observe(document.querySelector('[data-funnel-atc]'))

     var rechargeWidget =  setInterval(() => {
        if (document.querySelectorAll(".rc-radio__subscription").length > 0 ) {
          document.querySelector(".onetime-radio .rc-radio__label").innerHTML='<span>Order </span> <strong>Once </strong>'
          document.querySelector(".subscription-radio .rc-radio__label").innerText='Auto Refill:'
          document.querySelector(".rc-widget").insertAdjacentHTML("beforeend" ,`<div class='auto_refill'><strong>Auto-Refill: 15% off</strong> 1st order &amp; <strong>10% off</strong> recurring orders and Free shipping.</br>Subscriptions are already discounted and do not qualify towards the daily gift with purchase. <span style="color: #505050;">Free shipping does not apply to AK, HI, GUAM, PR and US Virgin Islands.</span></div>`);
          clearInterval(rechargeWidget);
        }
      }, 100);
      const ingredientAccordions = document.querySelectorAll('.toggle-ingredients');
        ingredientAccordions.forEach((menuIcon)=>{
          menuIcon.addEventListener('click', (e)=>{
            const parentElement = e.target.closest('.ingredients-dropdown');
            parentElement.querySelector(".toggle-content").style.height = `${0}px`
            if(parentElement.classList.contains('open')){
              this.toggleAccordionElement(parentElement, 'close');
            }else{
              this.toggleAccordionElement(parentElement, 'open');
            }
          });
      });
    }

  
  

  toggleAccordionElement(container, activity) {
    let contentBlock = container.querySelector('[data-type="content"]') || container.querySelector('.toggle-content');
    if(!contentBlock) return;
    let contentBlockHeight = contentBlock?.querySelector('[data-readmorecontainer]') || contentBlock?.querySelector('[data-small-content]') || contentBlock?.querySelector('div') || contentBlock;
    contentBlockHeight=contentBlockHeight.offsetHeight
    if(activity == 'open'){
      [contentBlock,container].forEach(ele => 
        ele.classList.add('open'));
        let parentEle = contentBlock.closest('.accordion__block.toggle-content.open');
        let parentHeight = parseInt(parentEle.style.height.replace("px",''));
        parentHeight = parentHeight + contentBlockHeight;
        parentEle.style.height = parentHeight + 'px';
        contentBlock.style.height = contentBlockHeight + 'px';
    }else{
      contentBlock.style.height = '0';
      if (contentBlock.closest('.accordion__block.toggle-content.open') != undefined) {
      let parentEle = contentBlock.closest('.accordion__block.toggle-content.open');
      let parentHeight = parseInt(parentEle.style.height.replace("px",''));
      parentHeight = parentHeight - contentBlockHeight;
      parentEle.style.height = parentHeight + 'px';
    }
      [contentBlock,container].forEach(ele => ele.classList.remove('open'));
    }
  }

}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();
